<template>
<form ref="form">
	<div v-if="Object.keys(badgeList).length > 0" style="text-align:center">
		<ul class="flex-parent four-columns">
			<li
				v-for="(value, key) in badgeList"
				:key="key"
			>
				<input :id="'badge-'+key"
					class="hide"
					:type="badgeGroup(key) ? 'radio' : 'checkbox'"
					:name="badgeGroup(key)"
					:checked="user && user.props && user.props.badges[key]"
					:value="key"
				>
				<label
					:for="'badge-'+key"
					:title="badgeHumanReadable(key)"
				>
					<img class="badge"
						:src="badgeIcon(key)"
					>
					<p>{{ badgeDescription(key) }}</p>
				</label>
			</li>
		</ul>
		<button class="submit left"
			@click.prevent="reset"
		>
			Reset
		</button>
		<button class="submit"
			@click.prevent="submit"
		>
			Submit
		</button>
	</div>
	<div v-else>
		<p>You don't have any badges to display. You can gain badges by subscribing to God Mode and by various other rewards given out.</p>
	</div>
</form>
</template>

<script>
import badges from '../json/shared/badges.json'
import socket from '../js/socket.js'
import $ from 'jquery'
import account from '../js/account.js'
// import rph from '../js/rph.js'

export default {
	props: {
		user: {
			type: [Boolean, Object, Array],
			required: true
		}
	},
	data: () => ({
		badges,
		selections: {}
	}),
	computed: {
		badgeList(){
			return account.priv.badges || []
		}
	},
	methods: {
		badgeDescription( badgeId ){
			return badges[badgeId] && badges[badges[badgeId]].description
		},
		badgeHumanReadable( badgeId ){
			const value = account.priv.badges[badgeId]
			return eval( badges[badgeId] && '`' + badges[badges[badgeId]].human_readable + '`' )
		},
		badgeGroup( badgeId ){
			return badges[badgeId] && badges[badges[badgeId]].group || false
		},
		badgeIcon( badgeId ){
			return badges[badgeId] && badges[badges[badgeId]].img_src || ''
		},
		reset( ev ){
			const inputs = Array.from( this.$refs.form.getElementsByTagName( 'input' ) )
			inputs.forEach( ( input ) => {
				input.checked = false
			})
		},
		submit(){
			const selections = Object.values( $( '#set-badges-dialog' ).find( 'input:checked' ).get() ).map( ( input ) => {
				return parseInt( input.value )
			})
			socket.emit( 'set-badges', {
				userid: this.user && this.user.props && this.user.props.id || false,
				selections
			})
			// rph.dialogs['Set Badges'].hide()
		}
	}
}
</script>